export default {
    checked: Boolean, 
    enabled: Boolean, 
    readonly: Boolean, 
    messages: Object, 
    width: Number | String, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSwitch/SwitchProps.js